export default {
	mask: '0000 0000 0000 0000',
}